/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

$(function () {
  secondary_text = "Complimentary Shipping On Orders Over $50";
  primary_text = $(".announcement__text").text();
  
  primary_color = "#005746";
  secondary_color = "#005746";
  
  primary_weight = 400;
  secondary_weight = 700;

  count = 0;
  textArray = [primary_text, secondary_text];
  colorArray = [primary_color, secondary_color];
  weightArray = [primary_weight, secondary_weight];
  
  setInterval(function () {
    count++;
    $(".announcement__text").fadeOut(400, function () {
      $(this).text(textArray[count % textArray.length]).fadeIn(400);
      $(".announcement__wrapper").css("background", colorArray[count % colorArray.length]);
    });
  }, 5000);
});